module.exports = __webpack_public_path__ + "img/738.92fb2f2c.jpg";